/***************
* *******
* *******
* Student App AI Agent
* *******
* *******
*
* Given a State, chooses an Action
*
* In this context, "State" is defined an object with three properties:
- a "story" (a piece of text representing the "right" answers for an activity)
- a student's interactions with that activity, up until the present (until the current State)
- additional data describing a student (e.g. AREA score)
*
* "Action" is an object describing an action that the student app should take.
*
* This wrapper takes in three params, one for each of the objects described above.
* The wrapper is configured prior to runtime to import and use a particular "policy".
*
* Each policy has a corresponding "transformer", which transforms input features
* into a format suitable for the policy to consume.
*
****************/

import {version as studentAppAIVersion} from './version';
import {version as heuristicPolicyVersion} from 'heuristic-policy/version';
export const versions = {
  'studentapp-ai': studentAppAIVersion,
  'heuristic-policy': heuristicPolicyVersion,
}

import InternalState from './InternalState';

// Import the current active policy, and corresponding data transformer / formatter
import { selectAction as selectActionViaHeuristicPolicy } from 'heuristic-policy';
import transform from './heuristicTransformer'; // transformers prep input data for a policy
import format from './interventionSelectionOutputFormatter'; // formatters prep output data for lexa-app

let internalState = new InternalState();

export default function selectAction(state) {

  // Reset internal state if this is the first phrase, but getInterventionHistoryByPhrase has more than one entry (meaning we have history from a previous activity)
  if(state.story.textMetadataForCurrentPhrase.phraseIndex == 0 &&
    internalState.getInterventionHistoryByPhrase().length > 1) {
    internalState = new InternalState();
  }

  // Transform data
  let transformedState = transform(state, internalState);
  if(transformedState.error) {
    console.log('ERROR PROCESSING SELECTION INPUT DATA: ' + transformedState.error + '\n bad state: '+JSON.stringify(state));
    // consider returning a NONE intervention if there's an error processing input features
    /*let action = {
      intervention: 'none',
      pauseLength: 0,
      index: 0,
      decisionContextAcrossPasses: 'ERROR PROCESSING SELECTION INPUT DATA'
    }
    return action;*/
  }

  // return whether there is a state error
  let logToSentry = false;
  // Note: intended to catch a bug which occurs when phrase metadata doesn't correspond to current phrase
  if(!transformedState.interventionHistoryByPhrase) {
    transformedState.interventionHistoryByPhrase = [];
    logToSentry = true;
  }

  // Select an action, and update internal state accordingly
  let action = selectActionViaHeuristicPolicy(transformedState);
  internalState.trackAction(action, state);

  // Format and return the selected action
  return {
    selection: format(action, state, internalState),
    logToSentry: logToSentry,
  };
}

export function testSelectAction(selection_log_json) {

  // parse state and intervention history from JSON
  let state = selection_log_json.features;
  state.confData = selection_log_json.confData; 

  class TestInternalStateFromJSON {
    constructor(history) {
      this.history = history;
    }

    getInterventionHistoryByPhrase() {
      return this.history;
    }
  }
  let history = selection_log_json.selection.history;
  if(!history) {
    history = [[]];
  }
  /*
  let lastPhraseHistory = history[history.length - 1];
  if(!lastPhraseHistory) {
    history[history.length - 1] = [];
  } else {
    lastPhraseHistory.pop()
    history[history.length - 1] = lastPhraseHistory;
  }*/
  if(selection_log_json.features.interactions.scope == 'phrase') { // remove the selection from history
    let lastPhraseHistory = history[history.length - 1];
    if(!lastPhraseHistory) {
      history[history.length - 1] = [];
    } else {
      lastPhraseHistory.pop()
      history[history.length - 1] = lastPhraseHistory;
    }
    // lastPhraseHistory.pop();
    // history[history.length - 1] = lastPhraseHistory;
  }

  let internalState = new TestInternalStateFromJSON(history);

  // Transform data
  let transformedState = transform(state, internalState);
  if(transformedState.error) {
    console.log('ERROR PROCESSING SELECTION INPUT DATA: ' + transformedState.error);
    // TODO return a NONE intervention if there's an error processing input features
  }
  if(!transformedState.interventionHistoryByPhrase) {
    transformedState.interventionHistoryByPhrase = [];
  }

  // Select an action, and update internal state accordingly
  let action = selectActionViaHeuristicPolicy(transformedState);

  // Format and return the selected action
  return format(action, state);
}





